function genSudoku () {
  const sudokus = [
    '800406007000000400010000650509030780000070000048020103052000090001000000300902005',
    '703000009000700008010054000020090030005201800080030010000560070500002000400000201',
    '060402005300800012000000070000190020003000600080043000050000000710009008900501040',
    '040076005009800010000000308000060400500409003001050000304000000070001600900780030',
    '310004200746028300009050000800240003000807000100036004000080600004390875008600049',
    '900704205004900076000103940608000307000607000702000504047502000190006400203408009',
    '500030109040109020700600003000005480000000000086900000400003006060201070807040002',
    '800604090740080000060000024150200000400106002000007056910000070000090068080305009',
    '001820950000010000600003007002070030090030010040050200700100009000080000015042300',
    '000700004070869000603040700507000000020050010000000208008090601000124090200006000'
  ]
  return sudokuToArray(sudokus[getRandomInt(11)])
}

function sudokuToArray (sudoku) {
  let str = sudoku
  let ar = str.split('')
  return ar
}

function getRandomInt (max) {
  return Math.floor(Math.random() * Math.floor(max))
}

export default genSudoku
